import { eventManager } from "@foretagsplatsen/yaem";
import jQuery from "jquery";

/**
 * User interactions do not always result in server calls, so a session might
 * expire even if the browser tab is open.
 *
 * To prevent that, a global click event listener is added to the body of the
 * page. The event handler will ping the server to keep the session alive.
 */
function sessionTimer(spec) {
	const that = {};

	spec ||= {};

	spec.pingUrl ||= "/Ping/Check";

	const pingInterval = 10 * 60 * 1000; // 10 minutes
	let lastPingDate = new Date();

	function pingServer() {
		jQuery.ajax(spec.pingUrl, {
			type: "GET",
			error: (jqXHR) => {
				if (jqXHR.status !== 403) {
					return;
				}
				eventManager.at("sync").trigger("session-expired");
			},
		});
	}

	function keepSessionAlive() {
		if (hasPingedRecently()) {
			return;
		}

		lastPingDate = new Date();
		pingServer();
	}

	function hasPingedRecently() {
		return new Date() - lastPingDate < pingInterval;
	}

	that.start = function () {
		jQuery("body").click(keepSessionAlive);
	};

	return that;
}

export default sessionTimer;
